export default theme => ({
  page_content_wrapper: {
    paddingTop: 25,
    paddingBottom: 25,
    position: "absolute",
    top: 66,
    bottom: 80,
    left: 0,
    right: 0,
    overflow: "auto",
  },
});
